import { __extends } from "tslib";
import { IgrStrategyBasedIndicator } from "./igr-strategy-based-indicator";
import { AbsoluteVolumeOscillatorIndicator } from "./AbsoluteVolumeOscillatorIndicator";
/**
 * Represents a IgxDataChartComponent Absolute Volume Oscillator indicator series.
 * Default required members: Volume
*
* You can use the `IgrAbsoluteVolumeOscillatorIndicator` to identify whether volume trands are increasing or decreasing.
*
* ```ts
* <IgrDataChart
*     dataSource={this.state.dataSource}
*     width="700px"
*     height="500px">
*
*
*     <IgrCategoryXAxis name="xAxis" label="Date" />
*     <IgrNumericYAxis  name="yAxis" />
*
*    <IgrAbsoluteVolumeOscillatorIndicator
*     name="series3"
*     xAxisName="xAxis"
*     yAxisName="yAxis"
*     displayType="Line"
*     lowMemberPath="Low"
*     highMemberPath="High"
*     openMemberPath="Open"
*     closeMemberPath="Close"
*     volumeMemberPath="Volume" />
*  </IgrDataChart>
* ```
*
* ```ts
* let series = new IgxAbsoluteVolumeOscillatorIndicatorComponent();
* series.xAxis = this.xAxis;
* series.yAxis = this.yAxis;
* series.openMemberPath = "open";
* series.highMemberPath = "high";
* series.lowMemberPath = "low";
* series.closeMemberPath = "close";
* this.chart.series.add(series);
* ```
*
* ```ts
* let series = new IgrAbsoluteVolumeOscillatorIndicator({name:"series3"});
* series.xAxisName = this.xAxis;
* series.yAxisName = this.yAxis;
* series.openMemberPath = "open";
* series.highMemberPath = "high";
* series.lowMemberPath = "low";
* series.closeMemberPath = "close";
* this.chart.series.add(series);
* ```
*/
var IgrAbsoluteVolumeOscillatorIndicator = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrAbsoluteVolumeOscillatorIndicator, _super);
    function IgrAbsoluteVolumeOscillatorIndicator(props) {
        return _super.call(this, props) || this;
    }
    IgrAbsoluteVolumeOscillatorIndicator.prototype.createImplementation = function () {
        return new AbsoluteVolumeOscillatorIndicator();
    };
    Object.defineProperty(IgrAbsoluteVolumeOscillatorIndicator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAbsoluteVolumeOscillatorIndicator.prototype, "shortPeriod", {
        /**
         * Gets or sets the short moving average period for the current AbsoluteVolumeOscillatorIndicator object.
         * The typical, and initial, value for short AVO periods is 10.
        *
        * You can use the `shortPeriod` to set the short moving average period.
        *
        * ```ts
        * <IgrDataChart
        *     dataSource={this.state.dataSource}
        *     width="700px"
        *     height="500px">
        *
        *
        *     <IgrCategoryXAxis name="xAxis" label="Date" />
        *     <IgrNumericYAxis  name="yAxis" />
        *
        *    <IgrAbsoluteVolumeOscillatorIndicator
        *     name="series3"
        *     xAxisName="xAxis"
        *     yAxisName="yAxis"
        *     displayType="Line"
        *     lowMemberPath="Low"
        *     highMemberPath="High"
        *     openMemberPath="Open"
        *     closeMemberPath="Close"
        *     volumeMemberPath="Volume"
        * 	shortPeriod="10" />
        *  </IgrDataChart>
        * ```
        *
        * ```ts
        * this.series.shortPeriod = 10;
        * ```
        */
        get: function () {
            return this.i.shortPeriod;
        },
        set: function (v) {
            this.i.shortPeriod = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAbsoluteVolumeOscillatorIndicator.prototype, "longPeriod", {
        /**
         * Gets or sets the short moving average period for the current AbsoluteVolumeOscillatorIndicator object.
         * The typical, and initial, value for long AVO periods is 30.
        *
        * You can use the `longPeriod` to set the long moving average period.
        *
        * ```ts
        * <IgrDataChart
        *     dataSource={this.state.dataSource}
        *     width="700px"
        *     height="500px">
        *
        *
        *     <IgrCategoryXAxis name="xAxis" label="Date" />
        *     <IgrNumericYAxis  name="yAxis" />
        *
        *    <IgrAbsoluteVolumeOscillatorIndicator
        *     name="series3"
        *     xAxisName="xAxis"
        *     yAxisName="yAxis"
        *     displayType="Line"
        *     lowMemberPath="Low"
        *     highMemberPath="High"
        *     openMemberPath="Open"
        *     closeMemberPath="Close"
        *     volumeMemberPath="Volume"
        * 	longPeriod=30/>
        *  </IgrDataChart>
        * ```
        *
        * ```ts
        * this.series.longPeriod = 30;
        * ```
        */
        get: function () {
            return this.i.longPeriod;
        },
        set: function (v) {
            this.i.longPeriod = +v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrAbsoluteVolumeOscillatorIndicator;
}(IgrStrategyBasedIndicator));
export { IgrAbsoluteVolumeOscillatorIndicator };
